// SCROLL ANITMATION EFFECTS
import $ from "jquery";
require("waypoints/lib/noframework.waypoints.min");
var $transitions = $(".text-animation");
$transitions.addClass("not-animated");
$transitions.each(function () {
  var $transition = $(this);
  new Waypoint({
    element: $transition[0],
    handler: (direction) => {
      if (direction == "down") {
        // console.log("down");
        $transition.removeClass("not-animated");
        $transition.addClass("animated");
      }
      if (direction == "up") {
        // console.log("up");
      }
    },
    offset: "98%",
  });
});